projects_map_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        properties.currentID = '';
        mapData.selectLayer.clearLayers();
        geojson_loader_handler.removeData();

        geojson_loader_handler.fetch({
          label: 'corridors',
          mapView: 'bike',
          url: 'bike',
          dataType: 'line',
          source: 'data/burlingame/prop_cs.json',
          preprocessJSONResponse: function(r) {
              // Sort by StudyCorridorOrder
              r.features = _.sortBy(r.features, function(f) {
                  return f.properties.StudyCorridorOrder;
              });
              return r;
          },
          style: {
            weight: 7,
            opacity: 1,
            "z-index": 1,
            className: 'proposed study-corridors',
          },
        });

        geojson_loader_handler.fetch({
          label: 'bike_class1',
          mapView: 'bike',
          url: 'bike',
          source: 'data/burlingame/prop_class1.json',
          style: {
            weight: 7,
            opacity: 1,
            className: 'proposed proposed-class1',
          },
        });
        
        geojson_loader_handler.fetch({
          label: 'bike_class2',
          mapView: 'bike',
          url: 'bike',
          source: 'data/burlingame/prop_class2.json',
          style: {
            weight: 7,
            opacity: 1,
            className: 'proposed proposed-class2',
          },
        });

        geojson_loader_handler.fetch({
          label: 'bike_class3',
          mapView: 'bike',
          url: 'bike',
          source: 'data/burlingame/prop_class3.json',
          style: {
            weight: 7,
            opacity: 1,
            className: 'proposed proposed-class3',
          },
        });

        geojson_loader_handler.fetch({
          label: 'bike_class3b',
          mapView: 'bike',
          url: 'bike',
          source: 'data/burlingame/prop_class3b.json',
          style: {
            weight: 7,
            opacity: 1,
            className: 'proposed proposed-class3b',
          },
        });

        geojson_loader_handler.fetch({
          label: 'bike_class4',
          mapView: 'bike',
          url: 'bike',
          source: 'data/burlingame/prop_class4.json',
          style: {
            weight: 7,
            opacity: 1,
            className: 'proposed proposed-class4',
          },
        });

        $('body').addClass('secondary-bg');

        
    },

    events: function() {
        var self = this;
        self.onLoad();

        $('.corridor-start-btn').click(function(event) {
        	$('#content-root, #map').toggleClass('swipe');
            if ($('#content-root').hasClass('swipe') == true){
                home_handler.scrollTop();
            }
            else {
                home_handler.scrollContent();
            }

            // Focus first corridor in list
            _.first( _.values(mapData.geoJSONLayers.corridors._layers) ).fireEvent('click');

            setTimeout(resizeMap, 150);
            return false;
        });
    }
}
